import Guest from '@/layouts/guest';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './intro.module.scss';

const Intro: React.FC<any> = () => {

  return (
    <section className={styles.intro}>
      <div className={styles.introContent}>
        <img src="/images/intro-blue.png" alt="تصویر پس زمینه" />
        <h2>به تکست نویس خوش آمدید</h2>
        <h3>تکست نویس، پلتفرمی جهت خرید و فروش تکست، بیت و ماکت</h3>
        <div>
          <Link to="/about" className={styles.btnGetStarted + " btn btn-primary"} title="درباره تکست نویس">
            <i className="fa fa-comment" /> درباره ما
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Intro;
